import { IconButton } from "@mui/material";
import ArrowLeftIcon from "components/icons/Components/ArrowLeft";
import { MutableRefObject } from "react";
import { IGif } from "services/types";
import "./PhotoSlider.scss";

interface IProps {
  gallery: IGif[];
  slidePrevArrow: MutableRefObject<any>;
  slideNextArrow: MutableRefObject<any>;
  sliderPagination: MutableRefObject<HTMLDivElement | null>;
}

const PhotoSlider = (props: IProps) => {
  const renderDotItem = (el: any, index: number) => {
    return (
      <div key={index} className="dot" />
    );
  };

  return (
    <div className="photoSlider">
      <IconButton ref={props.slidePrevArrow}>
        <ArrowLeftIcon/>
      </IconButton>
      <div className="dotsWrapper" ref={props.sliderPagination}>
        {props.gallery.map(renderDotItem)}
      </div>
      <IconButton
        ref={props.slideNextArrow}
        sx={{ transform: "rotate(180deg)" }}
      >
        <ArrowLeftIcon/>
      </IconButton>
    </div>
  );
};

export default PhotoSlider;
